import React from 'react';
import { useTranslation } from 'react-i18next';
import ProfileImage from '../../profileImage';

const SentRequestsList = ({
  requests,
  onCancel,
  isProcessing
}) => {
  const { t } = useTranslation();

  if (requests.length === 0) {
    return (
      <div className="text-center py-12 bg-gray-50 rounded-lg">
        <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
          </svg>
        </div>
        <h4 className="text-lg font-medium text-gray-900 mb-2">{t('player.parents.noSentRequests')}</h4>
        <p className="text-gray-600">{t('player.parents.noSentRequestsDescription')}</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {requests.map((request) => (
        <div key={request._id || request.id} className="bg-white border border-gray-200 rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <ProfileImage
                image={request.to?.profilePicture}
                alt={request.to?.userName}
                className="w-12 h-12 rounded-full object-cover"
              />
              <div>
                <h4 className="font-medium text-gray-900">
                  {request.to?.userName || `${request.to?.firstName} ${request.to?.lastName}`}
                </h4>
                <p className="text-sm text-gray-600">
                  {t('player.parents.access')}: {Array.isArray(request.role) ? request.role.join(', ') : request.role}
                </p>
                <p className="text-xs text-gray-500">
                  {new Date(request.createdAt).toLocaleDateString()}
                </p>
                <span className="inline-block px-2 py-1 bg-yellow-100 text-yellow-800 text-xs rounded-full">
                  {request.status ? t(`player.parents.status.${request.status}`) : t('player.parents.status.pending')}
                </span>
              </div>
            </div>
            <button
              onClick={() => onCancel(request._id || request.id)}
              disabled={isProcessing}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:bg-gray-300 transition-colors text-sm"
            >
              {isProcessing ? t('common.loading') : t('player.parents.cancel')}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SentRequestsList; 